(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["agnes-appointment"] && !Shopify.designMode) return;
  try {
    
  /* Mobile "Request Appointment" dialog: [data-appt-open] opens, [data-appt-close]
     (X + scrim) and Escape close. Locks body scroll, moves focus, and gates the
     dialog ARIA to mobile so the desktop/tablet inline form stays a plain form.
     Guarded so the shared section script binds its listeners only once. */
  (function () {
    if (window.AgnesApptDialogInit) return;
    window.AgnesApptDialogInit = true;

    var mq = window.matchMedia('(max-width: 749px)');
    var sel = '.agnes-appointment';

    function sectionOf(el) { return el.closest(sel); }
    function dialogOf(section) { return section.querySelector('.agnes-appointment__form'); }

    function syncAria(section) {
      var dialog = dialogOf(section);
      if (!dialog) return;
      if (mq.matches) {
        dialog.setAttribute('role', 'dialog');
        dialog.setAttribute('aria-modal', 'true');
        var title = section.querySelector('.agnes-appointment__dialog-heading');
        if (title && title.id) dialog.setAttribute('aria-labelledby', title.id);
        if (!section.classList.contains('is-open')) dialog.setAttribute('aria-hidden', 'true');
      } else {
        dialog.removeAttribute('role');
        dialog.removeAttribute('aria-modal');
        dialog.removeAttribute('aria-labelledby');
        dialog.removeAttribute('aria-hidden');
      }
    }

    function open(section) {
      if (section.classList.contains('is-open')) return;
      section._apptOpener = document.activeElement;
      section.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var dialog = dialogOf(section);
      if (dialog) {
        dialog.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(function () {
          var closeBtn = section.querySelector('.agnes-appointment__close');
          (closeBtn || dialog).focus();
        });
      }
    }

    function close(section) {
      if (!section.classList.contains('is-open')) return;
      section.classList.remove('is-open');
      document.body.style.overflow = '';
      var dialog = dialogOf(section);
      if (dialog) dialog.setAttribute('aria-hidden', 'true');
      var opener = section._apptOpener;
      if (opener && typeof opener.focus === 'function') opener.focus();
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-appt-open]');
      if (opener) { var s = sectionOf(opener); if (s) { e.preventDefault(); open(s); } return; }
      var closer = e.target.closest('[data-appt-close]');
      if (closer) { var s2 = sectionOf(closer); if (s2) { e.preventDefault(); close(s2); } }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      var openSection = document.querySelector(sel + '.is-open');
      if (openSection) close(openSection);
    });

    function init() {
      var sections = document.querySelectorAll(sel);
      Array.prototype.forEach.call(sections, function (section) {
        syncAria(section);
        /* Surface a submitted form (success/error) by opening the dialog on mobile. */
        if (mq.matches && section.querySelector('.agnes-appointment__note')) open(section);
      });
    }

    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init);

    var onChange = function () {
      Array.prototype.forEach.call(document.querySelectorAll(sel), syncAria);
    };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["agnes-collection-showcase"] && !Shopify.designMode) return;
  try {
    
  // Generic cross-fade slideshow: cycles its direct children by toggling
  // `.is-active`. Each host styles its own slide class (opacity + transition).
  class AgnesSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.children);
      if (this.slides.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.index = this.slides.findIndex((s) => s.classList.contains('is-active'));
      if (this.index < 0) {
        this.index = 0;
        this.slides[0].classList.add('is-active');
      }
      this.interval = Number(this.dataset.interval) || 4500;
      this.timer = setInterval(() => this.advance(), this.interval);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    advance() {
      this.slides[this.index].classList.remove('is-active');
      this.index = (this.index + 1) % this.slides.length;
      this.slides[this.index].classList.add('is-active');
    }
  }

  if (!customElements.get('agnes-slideshow')) {
    customElements.define('agnes-slideshow', AgnesSlideshow);
  }

  // Promo hover video: play the autolooping video on hover, pause on leave.
  // The slideshow keeps running underneath; the video (opacity via CSS) reveals over it.
  (function () {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Desktop-only, but decided PER EVENT — the old load-time gate left hover
    // videos dead when a narrow window was later maximised.
    const desktopHover = () =>
      window.innerWidth > 1024 && window.matchMedia('(hover: hover)').matches;
    const items = [];
    document.querySelectorAll('.agnes-collection__promo').forEach((host) => {
      const vid = host.querySelector('.agnes-collection__promo-video');
      if (!vid) return;
      items.push(vid);
      host.addEventListener('mouseenter', () => {
        if (!reduce && desktopHover()) { vid.play().catch(() => {}); }
      });
      host.addEventListener('mouseleave', () => { vid.pause(); });
    });
    // preload="none" made the FIRST hover download the clip cold (seconds of
    // nothing). Warm the buffer once the section approaches the viewport.
    if (items.length && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting || !desktopHover()) return;
          e.target.preload = 'auto';
          e.target.load();
          io.unobserve(e.target);
        });
      }, { rootMargin: '50%' });
      items.forEach((v) => io.observe(v));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["agnes-collection"] && !Shopify.designMode) return;
  try {
    
  class AgnesFacetDrawer extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.grid = document.querySelector('.agnes-catalog__grid');
      this.cards = this.grid ? Array.prototype.slice.call(this.grid.querySelectorAll('.agnes-product-card')) : [];
      this.features = this.grid ? Array.prototype.slice.call(this.grid.querySelectorAll('.agnes-catalog__feature')) : [];
      this.originalOrder = this.grid ? Array.prototype.slice.call(this.grid.children) : [];
      this.cards.forEach(function (c, i) { c.dataset.order = i; });

      this.openers = document.querySelectorAll('[data-open="' + this.id + '"]');
      this.openers.forEach(function (o) {
        o.addEventListener('click', function () { self._lastOpener = o; self.open(); });
      });
      this.querySelectorAll('[data-close]').forEach(function (el) {
        el.addEventListener('click', function () { self.close(); });
      });
      this.querySelectorAll('input[type="checkbox"][data-filter-group], input[data-sort]').forEach(function (i) {
        i.addEventListener('change', function () { self.apply(); });
      });
      this.querySelectorAll('[data-reset]').forEach(function (el) {
        el.addEventListener('click', function () { self.reset(); });
      });
      this._onKey = function (e) { if (e.key === 'Escape') self.close(); };
      this.apply();
    }

    selections() {
      var groups = {};
      this.querySelectorAll('input[type="checkbox"][data-filter-group]:checked').forEach(function (b) {
        var g = b.getAttribute('data-filter-group');
        (groups[g] = groups[g] || []).push(b.value);
      });
      return groups;
    }

    matches(card, groups) {
      for (var g in groups) {
        var tokens = (card.getAttribute('data-' + g) || '').toLowerCase().split(/[\s,]+/).filter(Boolean);
        var ok = groups[g].some(function (v) { return tokens.indexOf(v) !== -1; });
        if (!ok) return false;
      }
      return true;
    }

    cmp(a, b, mode) {
      if (mode === 'price-asc') return (+a.dataset.price) - (+b.dataset.price);
      if (mode === 'price-desc') return (+b.dataset.price) - (+a.dataset.price);
      if (mode === 'newest') return (+b.dataset.created) - (+a.dataset.created);
      return (+a.dataset.order) - (+b.dataset.order);
    }

    apply() {
      var self = this;
      var groups = this.selections();
      var filterActive = Object.keys(groups).length > 0;
      var radio = this.querySelector('input[data-sort]:checked');
      var mode = radio ? radio.value : 'recommended';
      var interacted = filterActive || mode !== 'recommended';

      if (!interacted) {
        // pristine view — restore original layout incl. feature tiles
        this.originalOrder.forEach(function (el) { el.style.display = ''; self.grid.appendChild(el); });
        this.updateBadges();
        this.updateCount(this.cards.length);
        return;
      }
      this.features.forEach(function (f) { f.style.display = 'none'; });
      var visible = this.cards.filter(function (card) { return self.matches(card, groups); });
      visible.sort(function (a, b) { return self.cmp(a, b, mode); });
      this.cards.forEach(function (card) { card.style.display = 'none'; });
      visible.forEach(function (card) { card.style.display = ''; self.grid.appendChild(card); });
      this.updateBadges();
      this.updateCount(visible.length);
    }

    updateBadges() {
      this.querySelectorAll('.agnes-catalog__facet--filter').forEach(function (group) {
        var chosen = [];
        group.querySelectorAll('input[type="checkbox"]:checked').forEach(function (b) {
          chosen.push(b.nextElementSibling ? b.nextElementSibling.textContent.trim() : b.value);
        });
        var count = group.querySelector('[data-facet-count]');
        var sel = group.querySelector('[data-facet-selected]');
        if (count) count.textContent = chosen.length ? ' (' + chosen.length + ')' : '';
        if (sel) sel.textContent = chosen.join(', ');
      });
    }

    updateCount(n) {
      var showCount = this.querySelector('[data-show-count]');
      if (showCount) showCount.textContent = n;
      var bar = document.querySelector('.agnes-catalog__count-num');
      if (bar) bar.textContent = n + (n === 1 ? ' item' : ' items');
    }

    reset() {
      this.querySelectorAll('input[type="checkbox"][data-filter-group]').forEach(function (b) { b.checked = false; });
      var first = this.querySelector('input[data-sort]');
      if (first) first.checked = true;
      this.apply();
    }

    open() {
      this.hidden = false;
      var self = this;
      requestAnimationFrame(function () { self.classList.add('is-open'); });
      document.addEventListener('keydown', this._onKey);
      document.body.style.overflow = 'hidden';
      var focusTarget = this.querySelector('.agnes-catalog__drawer-close');
      if (focusTarget) focusTarget.focus();
    }

    close() {
      this.classList.remove('is-open');
      document.removeEventListener('keydown', this._onKey);
      document.body.style.overflow = '';
      var self = this;
      window.setTimeout(function () { self.hidden = true; }, 450);
      if (this._lastOpener) this._lastOpener.focus();
    }
  }

  if (!customElements.get('agnes-facet-drawer')) {
    customElements.define('agnes-facet-drawer', AgnesFacetDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["agnes-editorial"] && !Shopify.designMode) return;
  try {
    
  // Generic cross-fade slideshow: cycles its direct children by toggling
  // `.is-active`. Guarded define — shared with other agnes sections.
  class AgnesSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.children);
      if (this.slides.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.index = this.slides.findIndex((s) => s.classList.contains('is-active'));
      if (this.index < 0) {
        this.index = 0;
        this.slides[0].classList.add('is-active');
      }
      this.interval = Number(this.dataset.interval) || 4500;
      this.timer = setInterval(() => this.advance(), this.interval);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    advance() {
      var next = (this.index + 1) % this.slides.length;
      var img = this.slides[next].querySelector('img');
      // Never cross-fade to an image that hasn't downloaded (a blank slide
      // reads as "the slideshow broke") — hold and retry next tick.
      if (img && !(img.complete && img.naturalWidth)) return;
      var go = () => {
        this.slides[this.index].classList.remove('is-active');
        this.index = next;
        this.slides[next].classList.add('is-active');
      };
      // Pre-decode off-frame so activation doesn't sync-decode a 2400px JPEG
      // mid-scrub (that decode spike was the visible stutter on every fade).
      if (img && img.decode) { img.decode().then(go, go); } else { go(); }
    }
  }

  if (!customElements.get('agnes-slideshow')) {
    customElements.define('agnes-slideshow', AgnesSlideshow);
  }

  /* Process steps → tap-to-expand accordions on phones only (delegated, one listener). */
  document.addEventListener('click', function (e) {
    var head = e.target.closest && e.target.closest('.agnes-editorial__step-head');
    if (!head) return;
    var step = head.parentElement;
    if (!step || !step.querySelector('.agnes-editorial__step-desc')) return;
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    step.classList.toggle('is-open');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["agnes-footer"] && !Shopify.designMode) return;
  try {
    
  // Mailchimp signup. Normal path is JSONP so the visitor never leaves the page.
  // When Mailchimp answers with a bot challenge, that challenge can only be
  // solved on Mailchimp's own page (they own both the widget and the
  // verification), so we hand the visitor over with a native POST instead of
  // dead-ending them.
  (function () {
    var form = document.querySelector('[data-mc-form]');
    if (!form) return;
    var note = form.querySelector('[data-mc-note]');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var human = form.querySelector('[data-mc-human]');
      if (human && !human.checked) {
        show('Please confirm you are a human first.', true);
        human.focus();
        return;
      }
      var email = form.querySelector('input[name="EMAIL"]');
      if (!email.value || email.validity.typeMismatch || email.validity.valueMissing) {
        show('Please enter a valid e-mail address.', true);
        return;
      }

      var cb = 'mcJsonp' + Date.now();
      var params = new URLSearchParams(new FormData(form));
      params.set('c', cb);
      var url = form.action.replace('/subscribe/post?', '/subscribe/post-json?') + '&' + params.toString();
      var s = document.createElement('script');
      var timer = setTimeout(function () {
        cleanup();
        show('That took longer than expected — please try again.', true);
      }, 12000);

      window[cb] = function (res) {
        clearTimeout(timer);
        cleanup();

        // Mailchimp signals a challenge as {"result":"redirect","msg":"captcha"}.
        // It can only be solved on their hosted page, so while reCAPTCHA is
        // enabled on the audience no inline signup can complete. Say so plainly
        // instead of sending the visitor off-site.
        if (res && res.result === 'redirect') {
          if (window.console && console.warn) {
            console.warn('[newsletter] Mailchimp demanded a captcha. Turn reCAPTCHA off for this audience (Forms > Settings > Audience-wide defaults).', res);
          }
          show('Sorry — we could not complete your signup just now. Please try again shortly.', true);
          return;
        }

        var raw = (res && res.msg) || '';
        var text = raw
          .replace(/^\d+\s*-\s*/, '')
          .replace(/<[^>]*>/g, '')
          .replace(/\s+/g, ' ')
          .trim();

        if (res && res.result === 'success') {
          form.querySelector('.agnes-footer__field').hidden = true;
          // Mailchimp's own wording is used so the message stays true whether the
          // audience is single or double opt-in.
          show(text || 'Thank you — please check your inbox to confirm your subscription.', false);
          return;
        }

        // Anything unreadable (empty, or bare "captcha") gets a human sentence.
        if (!text || /^captcha$/i.test(text)) {
          if (window.console && console.warn) console.warn('[newsletter] unreadable reply:', raw);
          show('Sorry — we could not complete your signup just now. Please try again shortly.', true);
          return;
        }

        // Everything else is a real, readable message worth showing verbatim
        // (e.g. "Too many subscribe attempts, please try again in 5 minutes").
        show(text, true);
      };

      function cleanup() {
        delete window[cb];
        if (s.parentNode) s.parentNode.removeChild(s);
      }

      s.src = url;
      s.onerror = function () {
        clearTimeout(timer);
        cleanup();
        show('We could not reach the signup service — please try again.', true);
      };
      document.head.appendChild(s);
    });

    // Button stays inert until the box is ticked, so the state is obvious
    // before the visitor clicks rather than after.
    var humanBox = form.querySelector('[data-mc-human]');
    var submitBtn = form.querySelector('.agnes-footer__submit');
    if (humanBox && submitBtn) {
      var syncSubmit = function () {
        submitBtn.disabled = !humanBox.checked;
        submitBtn.setAttribute('aria-disabled', String(!humanBox.checked));
      };
      humanBox.addEventListener('change', syncSubmit);
      syncSubmit();
    }

    function show(msg, isError) {
      if (!note) return;
      note.textContent = msg;
      note.hidden = false;
      note.classList.toggle('agnes-footer__note--error', !!isError);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["agnes-header"]) return;
  try {
    
  // EUR/USD selector: options submit Shopify's localization form (currency
  // follows the selected market's country; EUR is the store default).
  (function () {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-currency-toggle]');
      var option = e.target.closest('[data-currency-option]');
      document.querySelectorAll('[data-currency].is-open').forEach(function (box) {
        if (!toggle || box !== toggle.closest('[data-currency]')) {
          box.classList.remove('is-open');
          var b = box.querySelector('[data-currency-toggle]');
          if (b) b.setAttribute('aria-expanded', 'false');
        }
      });
      if (toggle) {
        var box = toggle.closest('[data-currency]');
        var open = box.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
      } else if (option) {
        var form = document.getElementById('AgnesLocalizationForm');
        var input = form && form.querySelector('[data-loc-country]');
        if (form && input) {
          input.value = option.getAttribute('data-country');
          form.submit();
        }
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-currency].is-open').forEach(function (box) {
        box.classList.remove('is-open');
        var b = box.querySelector('[data-currency-toggle]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    });
  })();

  class AgnesHeader extends HTMLElement {
    constructor() {
      super();
      this.toggle = this.querySelector('.agnes-header__toggle');
      this.drawer = this.querySelector('.agnes-header__drawer');
      if (this.toggle && this.drawer) {
        this.toggle.addEventListener('click', () => this.onToggle());
      }
      this._lastY = window.pageYOffset || 0;
      this._hidden = null;
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    onScroll() {
      var y = window.pageYOffset || 0;
      // Solid background once past the hero (overlay mode only).
      if (this.dataset.overlay === 'true') this.classList.toggle('is-solid', y > 40);
      // Auto-hide: slide up when scrolling down, reveal when scrolling back up;
      // always shown near the top. Never hide while the mobile drawer is open.
      if (!this.classList.contains('is-open')) {
        var dy = y - this._lastY;
        if (y <= 80) this.classList.remove('is-hidden');
        else if (dy > 4) this.classList.add('is-hidden');
        else if (dy < -4) this.classList.remove('is-hidden');
      }
      // Publish the nav's visible bottom edge so sticky elements (e.g. catalog filter
      // bar) track it: 8.7rem when shown, 0 when hidden.
      var hidden = this.classList.contains('is-hidden');
      if (hidden !== this._hidden) {
        this._hidden = hidden;
        document.documentElement.style.setProperty('--nav-offset', hidden ? '0px' : '8.7rem');
      }
      this._lastY = y;
    }

    onToggle() {
      const open = this.classList.toggle('is-open');
      // A hidden (translated) header makes its wrapper a containing block for
      // position:fixed — the open drawer would anchor to the DOCUMENT top,
      // thousands of px out of view when scrolled. Always reveal on open.
      if (open) this.classList.remove('is-hidden');
      this.toggle.setAttribute('aria-expanded', String(open));
      this.drawer.setAttribute('aria-hidden', String(!open));
      document.body.style.overflow = open ? 'hidden' : '';
    }
  }

  if (!customElements.get('agnes-header')) {
    customElements.define('agnes-header', AgnesHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["agnes-product"] && !Shopify.designMode) return;
  try {
    
  // Fullscreen viewer — Dior-style vertical filmstrip: full-height slides with
  // snap scrolling, a thumbnail rail for direct jumps, click-to-zoom on a
  // slide, Esc/X to close. data-lenis-prevent keeps Lenis off the scroller.
  (function () {
    var viewer = document.querySelector('[data-viewer]');
    if (!viewer) return;
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-viewer-item]'));
    var scroller = viewer.querySelector('[data-viewer-scroll]');
    var slides = Array.prototype.slice.call(viewer.querySelectorAll('[data-viewer-slide]'));
    var thumbs = Array.prototype.slice.call(viewer.querySelectorAll('[data-viewer-thumb]'));
    if (!items.length || !slides.length) return;
    var current = -1;
    var setCurrent = function (i) {
      if (i === current) return;
      current = i;
      thumbs.forEach(function (th, k) { th.classList.toggle('is-current', k === i); });
    };
    var unzoomAll = function () {
      slides.forEach(function (s) {
        s.classList.remove('is-zoomed');
        var im = s.querySelector('img');
        if (im) im.style.transform = '';
      });
    };
    var open = function (i) {
      viewer.hidden = false;
      requestAnimationFrame(function () { viewer.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      unzoomAll();
      scroller.scrollTop = i * scroller.clientHeight;
      setCurrent(i);
      scroller.focus({ preventScroll: true });
    };
    var close = function () {
      viewer.classList.remove('is-open');
      document.body.style.overflow = '';
      window.setTimeout(function () { viewer.hidden = true; }, 300);
    };
    items.forEach(function (item, i) {
      item.addEventListener('click', function () { open(i); });
    });
    viewer.querySelector('[data-viewer-close]').addEventListener('click', close);
    thumbs.forEach(function (th, i) {
      th.addEventListener('click', function () {
        unzoomAll();
        scroller.scrollTo({ top: i * scroller.clientHeight, behavior: 'smooth' });
      });
    });
    scroller.addEventListener('scroll', function () {
      setCurrent(Math.round(scroller.scrollTop / scroller.clientHeight));
    }, { passive: true });
    slides.forEach(function (slide) {
      var im = slide.querySelector('img');
      if (!im) return;
      im.addEventListener('click', function (e) {
        var zoomed = slide.classList.toggle('is-zoomed');
        if (zoomed) {
          var r = im.getBoundingClientRect();
          im.style.transformOrigin = (((e.clientX - r.left) / r.width) * 100) + '% ' + (((e.clientY - r.top) / r.height) * 100) + '%';
          im.style.transform = 'scale(2)';
        } else {
          im.style.transform = '';
        }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (viewer.hidden) return;
      if (e.key === 'Escape') close();
    });
  })();

  class AgnesTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.agnes-product__tab'));
      this.panels = Array.from(this.querySelectorAll('.agnes-product__tabpanel'));
      var self = this;
      this.tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          self.activate(tab.getAttribute('data-tab'));
        });
      });
    }

    activate(name) {
      var wrap = this.querySelector('.agnes-product__panels');
      var from = wrap ? wrap.offsetHeight : 0;
      if (wrap) {
        clearTimeout(this._animT);
        wrap.style.transition = 'none';
        wrap.style.height = '';
      }
      this.tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-tab') === name;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-panel') !== name;
        if (!panel.hidden) {
          var rm = panel.querySelector('agnes-readmore');
          if (rm && rm._check) rm._check();
        }
      });
      if (!wrap) return;
      var to = wrap.offsetHeight;
      if (Math.abs(to - from) < 2) { wrap.style.transition = ''; return; }
      wrap.style.height = from + 'px';
      wrap.style.overflow = 'hidden';
      void wrap.offsetHeight;
      wrap.style.transition = 'height 0.5s cubic-bezier(0.22, 1, 0.36, 1)';
      wrap.style.height = to + 'px';
      this._animT = setTimeout(function () {
        wrap.style.height = wrap.style.overflow = wrap.style.transition = '';
      }, 560);
    }
  }
  if (!customElements.get('agnes-tabs')) customElements.define('agnes-tabs', AgnesTabs);

  class AgnesVariantPicker extends HTMLElement {
    connectedCallback() {
      var json = this.querySelector('[data-variants]');
      this.variants = json ? JSON.parse(json.textContent) : [];
      var priceJson = this.querySelector('[data-variant-prices]');
      this.prices = priceJson ? JSON.parse(priceJson.textContent) : {};
      this.form = this.closest('form');
      this.idInput = this.form ? this.form.querySelector('[data-variant-id]') : null;
      var self = this;
      this.querySelectorAll('input[type="radio"]').forEach(function (input) {
        input.addEventListener('change', function () {
          self.onChange();
        });
      });
    }

    onChange() {
      var chosen = [];
      this.querySelectorAll('.agnes-product__option').forEach(function (fieldset) {
        var checked = fieldset.querySelector('input:checked');
        if (checked) chosen.push(checked.value);
      });
      var variant = this.variants.find(function (v) {
        return v.options.length === chosen.length && v.options.every(function (o, i) { return o === chosen[i]; });
      });
      if (!variant) return;

      if (this.idInput) this.idInput.value = variant.id;

      var formatted = this.prices[variant.id] || '';
      var priceEl = document.querySelector('[data-price]');
      if (priceEl && formatted) priceEl.textContent = formatted;
      var addPrice = document.querySelector('[data-add-price]');
      if (addPrice && formatted) addPrice.textContent = formatted;

      var btn = this.form ? this.form.querySelector('.agnes-product__add') : null;
      var label = document.querySelector('[data-add-label]');
      if (btn) {
        btn.disabled = !variant.available;
        if (label) label.textContent = variant.available ? (label.getAttribute('data-default-label') || 'Add to bag') : 'Item not available';
        if (addPrice) addPrice.textContent = variant.available ? formatted : 'SOLD';
      }
      var panel = document.querySelector('.agnes-product__panel');
      if (panel) panel.classList.toggle('is-soldout', !variant.available);

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }
  }
  if (!customElements.get('agnes-variant-picker')) customElements.define('agnes-variant-picker', AgnesVariantPicker);

  // Description read-more: shows the "View More" toggle only when the copy
  // actually overflows the 3-line clamp; expands/collapses on click.
  class AgnesReadmore extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-readmore-content]');
      this.btn = this.querySelector('[data-readmore-toggle]');
      if (!this.content || !this.btn) return;
      var self = this;
      this.moreLabel = this.btn.textContent.trim() || 'View More';
      this.lessLabel = this.btn.getAttribute('data-less-label') || 'View Less';
      this.btn.addEventListener('click', function () { self.toggle(); });
      this._check = this._check.bind(this);
      requestAnimationFrame(this._check);
      window.addEventListener('resize', this._check);
      // Fonts change line metrics after load — re-measure once they're ready.
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this._check);
    }

    _check() {
      var wasExpanded = this.classList.contains('is-expanded');
      if (wasExpanded) this.classList.remove('is-expanded');
      var overflows = this.content.scrollHeight - this.content.clientHeight > 2;
      if (wasExpanded) this.classList.add('is-expanded');
      this.btn.hidden = !overflows;
    }

    toggle() {
      var el = this.content;
      var self = this;
      var from = el.offsetHeight;
      // Settle any in-flight animation so both measurements are honest.
      clearTimeout(this._animT);
      el.style.transition = 'none';
      el.style.height = '';
      this.classList.remove('is-animating');
      var expanded = this.classList.toggle('is-expanded');
      this.btn.textContent = expanded ? this.lessLabel : this.moreLabel;
      this.btn.setAttribute('aria-expanded', String(expanded));
      var to = el.offsetHeight;
      if (Math.abs(to - from) < 2) { el.style.transition = ''; return; }
      this.classList.add('is-animating');
      el.style.height = from + 'px';
      el.style.overflow = 'hidden';
      void el.offsetHeight;
      el.style.transition = 'height 0.5s cubic-bezier(0.22, 1, 0.36, 1)';
      el.style.height = to + 'px';
      this._animT = setTimeout(function () {
        el.style.height = el.style.overflow = el.style.transition = '';
        self.classList.remove('is-animating');
      }, 560);
      var panels = this.closest('.agnes-product__panels');
      if (panels) panels.querySelectorAll('agnes-readmore').forEach(function (rm) {
        if (rm !== self && rm.setState) rm.setState(expanded);
      });
    }

    /* Silent state sync from a sibling tab's toggle — no animation (hidden). */
    setState(expanded) {
      if (!this.btn) return;
      this.classList.toggle('is-expanded', expanded);
      this.btn.textContent = expanded ? this.lessLabel : this.moreLabel;
      this.btn.setAttribute('aria-expanded', String(expanded));
    }
  }
  if (!customElements.get('agnes-readmore')) customElements.define('agnes-readmore', AgnesReadmore);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["agnes-spinner"] && !Shopify.designMode) return;
  try {
    
  class AgnesSpinner extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('[data-stage]');
      this.videos = Array.prototype.slice.call(this.querySelectorAll('[data-video]'));
      this.swatches = Array.prototype.slice.call(this.querySelectorAll('[data-swatch]'));
      this.label = this.querySelector('[data-label]');
      this.stitchesEl = this.querySelector('.agnes-spinner__stat-num[data-stitches]');
      this.viewLink = this.querySelector('[data-view]');
      if (!this.videos.length) return;
      var self = this;

      this.active = this.videos.findIndex(function (v) { return v.classList.contains('is-active'); });
      if (this.active < 0) this.active = 0;
      this.dragRange = parseFloat(this.dataset.dragRange) || 1;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.dragging = false;
      this._tok = 0;
      this._rafPending = false;
      this.ready = false;
      this._warmed = {};
      this._applyScrub = this._applyScrub.bind(this);

      this.swatches.forEach(function (s, i) {
        s.addEventListener('click', function () { self.select(i); });
      });

      this.stage.addEventListener('pointerdown', function (e) { self.onDown(e); });
      this._move = function (e) { self.onMove(e); };
      this._up = function (e) { self.onUp(e); };

      // Re-center the label under the active swatch, and once fonts settle.
      this.positionLabel();
      window.addEventListener('resize', function () { self.positionLabel(); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { self.positionLabel(); });

      // macOS-dock swatch magnification (mouse only): the swatch nearest the cursor
      // grows to the active size, neighbours scale down smoothly with distance.
      this.swatchRow = this.querySelector('[data-swatches]');
      if (this.swatchRow && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        this._dockX = 0;
        this._dockRaf = false;
        this._applyDock = this._applyDock.bind(this);
        this.swatchRow.addEventListener('pointermove', function (e) {
          self._dockX = e.clientX;
          if (!self._dockRaf) { self._dockRaf = true; requestAnimationFrame(self._applyDock); }
        });
        this.swatchRow.addEventListener('pointerleave', function () {
          self._dockRaf = false;
          self.swatches.forEach(function (s) { s.style.removeProperty('--sw-scale'); }); // back to CSS idle
        });
      }

      // Sticky-scroll left text: rides down from near the top of the section to its
      // bottom-left resting spot as the section scrolls fully into view.
      this.textEl = this.querySelector('[data-text]');
      if (this.textEl && window.matchMedia('(min-width: 990px)').matches) {
        this._scrollRaf = false;
        this._applyTextShift = this._applyTextShift.bind(this);
        this._onScroll = function () { if (!self._scrollRaf) { self._scrollRaf = true; requestAnimationFrame(self._applyTextShift); } };
        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onScroll);
        this._applyTextShift();
      }

      // Custom drag cursor (mouse only): a pill that trails the pointer with ease over the
      // draggable stage; its rotate icon faces the drag direction.
      this.cursorEl = this.querySelector('[data-cursor]');
      if (this.cursorEl && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        this._cur = { x: 0, y: 0, tx: 0, ty: 0, lastX: 0, shown: false, primed: false, raf: false };
        this._lerpCursor = this._lerpCursor.bind(this);
        this.addEventListener('pointermove', function (e) { self.onCursorMove(e); });
        this.addEventListener('pointerleave', function () { self.setCursorShown(false); });
      }

      // Shrink the (dynamic) stitches number so it never overflows its card — our FreightBig
      // renders digits a touch wider than the 70px design, so the long value needs fitting.
      this.fitStat();
      window.addEventListener('resize', function () { self.fitStat(); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { self.fitStat(); });

      // Drag is gated behind `is-preparing` until the active clip is fully buffered, so the
      // first scrub is smooth, not janky. (playActive() is deferred to warmActive so the
      // clip can buffer paused — see there.)
      this.classList.add('is-preparing');
      var conn = navigator.connection || {};
      var saveData = conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');
      if (saveData || typeof fetch !== 'function') {
        // Metered / very slow / no fetch: don't pull ~100MB — fall back to progressive.
        this.warm();
        this.markWarmed(this.active);
        this.playActive();
      } else {
        this.warmActive();
      }
    }

    disconnectedCallback() {
      window.clearTimeout(this._activeTimer);
      if (this._onScroll) {
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onScroll);
      }
    }

    get video() { return this.videos[this.active]; }

    // Dock magnification: scale each swatch by the cursor's proximity to its centre
    // (raised-cosine falloff). Centre is invariant under centre-origin scale, so no wobble.
    _applyDock() {
      this._dockRaf = false;
      var x = this._dockX, self = this;
      var MAX = 1.38, R = 132; // peak scale = active size; influence radius (px)
      this.swatches.forEach(function (s, i) {
        if (i === self.active) { s.style.removeProperty('--sw-scale'); return; } // active never resizes on hover
        var r = s.getBoundingClientRect();
        var c = r.left + r.width / 2;
        var d = Math.abs(x - c);
        var f = d < R ? 0.5 * (1 + Math.cos(Math.PI * d / R)) : 0;
        s.style.setProperty('--sw-scale', (1 + (MAX - 1) * f).toFixed(3));
      });
    }

    // Map the section's entry progress (0 = just entering at the viewport bottom,
    // 1 = fully placed, section top at 0) to how far the left text is lifted toward the top.
    _applyTextShift() {
      this._scrollRaf = false;
      if (!this.textEl) return;
      var rect = this.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      // Fully placed = section top at 0 (full-height section; nav auto-hides, not subtracted).
      var p = vh > 0 ? (vh - rect.top) / vh : 1;
      p = p < 0 ? 0 : (p > 1 ? 1 : p);
      var travel = rect.height - this.textEl.offsetHeight - 108; // section minus ~top+bottom padding
      if (travel < 0) travel = 0;
      this.textEl.style.setProperty('--text-shift', (-(1 - p) * travel).toFixed(1) + 'px');
    }

    onCursorMove(e) {
      var c = this._cur;
      c.tx = e.clientX; c.ty = e.clientY;
      // horizontal travel direction → face the rotate arrow the way you drag
      // (Figma arrow is drawn pointing right, so flip only when moving left)
      var dx = e.clientX - c.lastX; c.lastX = e.clientX;
      if (dx > 1.2) this.cursorEl.classList.remove('is-dir-left');
      else if (dx < -1.2) this.cursorEl.classList.add('is-dir-left');
      // show only over the draggable stage — not over the swatch menu or the button
      var overControl = e.target && e.target.closest && e.target.closest('.agnes-spinner__swatch, .agnes-spinner__btn, .agnes-spinner__menu');
      this.setCursorShown(!overControl && !this.classList.contains('is-preparing'));
      if (!c.raf) { c.raf = true; requestAnimationFrame(this._lerpCursor); }
    }

    setCursorShown(on) {
      if (!this._cur || on === this._cur.shown) return;
      this._cur.shown = on;
      this.classList.toggle('is-cursor-on', on);
    }

    _lerpCursor() {
      var c = this._cur;
      c.raf = false;
      if (!c.primed) { c.x = c.tx; c.y = c.ty; c.primed = true; } // land in place, don't fly in from 0,0
      c.x += (c.tx - c.x) * 0.2; // easing (trail)
      c.y += (c.ty - c.y) * 0.2;
      this.cursorEl.style.setProperty('--cx', c.x.toFixed(1) + 'px');
      this.cursorEl.style.setProperty('--cy', c.y.toFixed(1) + 'px');
      if (Math.abs(c.tx - c.x) > 0.4 || Math.abs(c.ty - c.y) > 0.4) { c.raf = true; requestAnimationFrame(this._lerpCursor); }
    }

    // Shrink the stitches number until its ink fits the card content box (with a little room).
    fitStat() {
      var el = this.stitchesEl;
      if (!el) return;
      el.style.fontSize = '';
      var box = el.clientWidth;
      if (!box) return;
      var target = box - 8, size = parseFloat(getComputedStyle(el).fontSize) || 70, guard = 0;
      var range = document.createRange();
      var ink = function () { range.selectNodeContents(el); return range.getBoundingClientRect().width; };
      while (ink() > target && size > 34 && guard < 60) { size -= 1; el.style.fontSize = size + 'px'; guard++; }
    }

    warm() {
      this.videos.forEach(function (v) {
        if (v.getAttribute('preload') !== 'auto') { v.setAttribute('preload', 'auto'); try { v.load(); } catch (e) {} }
      });
    }

    srcOf(i) {
      var v = this.videos[i];
      if (!v) return '';
      var s = v.querySelector('source');
      return (s && s.getAttribute('src')) || v.currentSrc || v.getAttribute('src') || '';
    }

    markWarmed(i) {
      this._warmed[i] = true;
      if (i === this.active) { this.ready = true; this.classList.remove('is-preparing'); }
    }

    // Download one clip in full so its bytes land in the HTTP cache; the <video> then
    // seeks straight from cache (verified: far-seeks drop ~110ms→~30ms, buffered 28%→100%),
    // so scrubbing never blocks on a mid-drag range request. The bytes are dropped after —
    // the disk cache keeps them, so no memory bloat. Failures degrade to progressive.
    prefetch(i) {
      var self = this, v = this.videos[i];
      if (!v || this._warmed[i]) return Promise.resolve();
      if (v.getAttribute('preload') !== 'auto') { v.setAttribute('preload', 'auto'); try { v.load(); } catch (e) {} }
      var url = this.srcOf(i);
      if (!url || typeof fetch !== 'function') { this.markWarmed(i); return Promise.resolve(); }
      return fetch(url, { cache: 'force-cache', mode: 'cors', credentials: 'omit' })
        .then(function (r) { return (r && r.ok) ? r.arrayBuffer() : null; })
        .then(function () { self.markWarmed(i); })
        .catch(function () { self.markWarmed(i); });
    }

    bufferedFraction(v) {
      if (!v || !v.duration || isNaN(v.duration)) return 0;
      var s = 0;
      for (var i = 0; i < v.buffered.length; i++) s += v.buffered.end(i) - v.buffered.start(i);
      return s / v.duration;
    }

    // Warm the active clip with a full fetch (reliable = whole file cached = smooth scrub),
    // but keep its <video> PAUSED and preload="metadata" during the fetch so the video isn't
    // reading the same cache entry. A *playing* video reads that entry at 1× and the fetch
    // stalls behind it (~15s on a normal reload); idling the video lets the fetch own the
    // cache fill. When it's warm, flip the video to auto + play, and pull the rest.
    warmActive() {
      var self = this, v = this.videos[this.active], restStarted = false;
      var startRest = function () { if (!restStarted) { restStarted = true; self.prefetchRest(); } };
      var done = function () {
        if (self._warmed[self.active]) return;
        if (v) v.setAttribute('preload', 'auto'); // now buffer/play from the warm cache
        self.markWarmed(self.active);             // clears is-preparing → enables drag
        self.playActive();                        // bring the loop to life
        startRest();
      };
      if (!v) { this.markWarmed(this.active); startRest(); return; }
      try { v.pause(); } catch (e) {}
      v.setAttribute('preload', 'metadata'); // stop the video from filling the cache itself
      var url = this.srcOf(this.active);
      if (!url || typeof fetch !== 'function') { done(); return; }
      fetch(url, { cache: 'force-cache', mode: 'cors', credentials: 'omit' })
        .then(function (r) { return (r && r.ok) ? r.arrayBuffer() : null; })
        .then(done).catch(done);
    }

    prefetchRest() {
      var self = this;
      // All remaining clips at once — the default is already cached, so this fills the
      // rest as fast as the connection allows.
      return Promise.all(this.videos.map(function (v, i) {
        return i === self.active ? null : self.prefetch(i);
      }));
    }

    playActive() {
      if (this.reduced) return;
      var v = this.video;
      if (v && v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }

    select(i) {
      if (i === this.active || !this.videos[i]) return;
      var self = this, prev = this.active;
      var from = this.videos[prev], to = this.videos[i];
      var t = from ? from.currentTime : 0;

      // Instant UI feedback (swatch highlight, name, stat, link).
      this.swatches[prev].classList.remove('is-active');
      this.swatches[i].classList.add('is-active');
      this.swatches[i].style.removeProperty('--sw-scale'); // the new active shows its CSS size, not a stale dock scale
      this.active = i;
      var d = this.swatches[i].dataset;
      if (this.label && d.name) this.label.textContent = d.name;
      if (this.stitchesEl && d.stitches) { this.stitchesEl.textContent = d.stitches; this.fitStat(); }
      if (this.viewLink && d.link) { this.viewLink.setAttribute('href', d.link); this.viewLink.removeAttribute('aria-disabled'); }
      this.positionLabel();

      // Gate scrubbing on this clip being buffered too, and jump it to the front of
      // the prefetch queue so it's ready fast.
      if (this._warmed[i]) { this.ready = true; this.classList.remove('is-preparing'); }
      else { this.ready = false; this.classList.add('is-preparing'); this.prefetch(i); }

      // Cross-fade the new clip in only once it's parked on the matching frame, so
      // no stale frame flashes before the sync. Idempotent under rapid switches.
      var token = ++this._tok;
      to.pause();
      // Instant, transition-free hide + cleanup of wipe leftovers — under rapid
      // switching an interrupted wipe's onComplete never runs, so stale state
      // must be scrubbed at the start of every reveal.
      var hardHide = function (v) {
        v.style.transition = 'none';
        v.classList.remove('is-active');
        v.pause();
        v.style.clipPath = '';
        v.style.zIndex = '';
        v.style.webkitMaskImage = '';
        v.style.maskImage = '';
        v.style.removeProperty('--wipe');
        void v.offsetWidth;
        v.style.transition = '';
      };
      var reveal = function () {
        if (token !== self._tok) return;
        var old = (prev >= 0 && prev !== i) ? self.videos[prev] : null;
        var wipe = !!(window.gsap && !self.reduced && old);
        self.videos.forEach(function (v, idx) {
          if (window.gsap) window.gsap.killTweensOf(v);
          if (idx === i) {
            v.style.clipPath = '';
            v.style.zIndex = '';
            v.style.webkitMaskImage = '';
            v.style.maskImage = '';
            v.style.removeProperty('--wipe');
            v.classList.add('is-active');
          } else if (wipe && idx === prev) {
            v.style.clipPath = '';
            v.style.zIndex = '';
            v.style.webkitMaskImage = '';
            v.style.maskImage = '';
            v.style.removeProperty('--wipe');
          } else {
            hardHide(v);
          }
        });
        // The new clip always sweeps in LEFT → RIGHT over the still-visible old
        // one, behind a mask gradient whose leading edge is feathered (~7% of
        // the width) so the wipe line reads soft, not razor-sharp. The edge
        // position rides a CSS variable so killTweensOf(video) still cancels
        // an interrupted sweep. The old clip is released once fully covered.
        if (wipe) {
          window.gsap.set(to, { zIndex: 2 });
          var wipeMask = 'linear-gradient(90deg, #000 calc(var(--wipe) - 7%), rgba(0,0,0,0) var(--wipe))';
          to.style.webkitMaskImage = wipeMask;
          to.style.maskImage = wipeMask;
          window.gsap.fromTo(to,
            { '--wipe': '0%' },
            { '--wipe': '110%', duration: 1.3, ease: 'power2.out', overwrite: 'auto',
              onComplete: function () {
                to.style.webkitMaskImage = '';
                to.style.maskImage = '';
                to.style.removeProperty('--wipe');
                if (token === self._tok && old) hardHide(old);
                window.gsap.set(to, { clearProps: 'zIndex' });
              } });
        }
        if (!self.reduced && !self.dragging) { var p = to.play(); if (p && p.catch) p.catch(function () {}); }
      };

      if (to.readyState >= 1 && Math.abs((to.currentTime || 0) - t) > 0.03) {
        var done = false;
        var onSeeked = function () { if (done) return; done = true; to.removeEventListener('seeked', onSeeked); reveal(); };
        to.addEventListener('seeked', onSeeked);
        try { to.currentTime = t; } catch (e) { done = true; reveal(); }
        window.setTimeout(function () { if (!done) { done = true; to.removeEventListener('seeked', onSeeked); reveal(); } }, 220);
      } else if (to.readyState >= 1) {
        reveal();
      } else {
        to.setAttribute('preload', 'auto');
        to.addEventListener('loadedmetadata', function () {
          try { to.currentTime = t; } catch (e) {}
          to.addEventListener('seeked', reveal, { once: true });
          window.setTimeout(reveal, 400);
        }, { once: true });
        try { to.load(); } catch (e) {}
      }
    }

    positionLabel() {
      if (!this.label || !this.swatches[this.active]) return;
      var s = this.swatches[this.active];
      this.label.style.left = (s.offsetLeft + s.offsetWidth / 2) + 'px';
      this.label.style.transform = 'translateX(-50%)';
    }

    onDown(e) {
      if (e.button != null && e.button !== 0) return;
      if (!this.video) return;
      // Not buffered yet → don't start a stuttery drag; the loader is showing and the
      // active clip is already prefetching, so it unlocks the moment it's ready.
      if (!this._warmed[this.active]) { this.prefetch(this.active); return; }
      this.dragging = true;
      this.startX = e.clientX;
      this.pendingX = e.clientX;
      this.startTime = this.video.currentTime || 0;
      this.video.pause();
      this.classList.add('is-dragging');
      try { this.stage.setPointerCapture(e.pointerId); } catch (err) {}
      window.addEventListener('pointermove', this._move);
      window.addEventListener('pointerup', this._up);
      window.addEventListener('pointercancel', this._up);
    }

    onMove(e) {
      if (!this.dragging) return;
      this.pendingX = e.clientX;
      if (!this._rafPending) { this._rafPending = true; requestAnimationFrame(this._applyScrub); }
    }

    // One seek per animation frame — coalesces rapid pointermoves so the seek
    // queue never thrashes (a main cause of scrub stutter).
    _applyScrub() {
      this._rafPending = false;
      if (!this.dragging || !this.video) return;
      var dur = this.video.duration;
      if (!dur || isNaN(dur)) return;
      var w = this.stage.clientWidth || 1;
      var delta = this.pendingX - this.startX;
      var t = this.startTime - (delta / w) * dur * this.dragRange;
      t = ((t % dur) + dur) % dur; // wrap for a seamless loop
      try { this.video.currentTime = t; } catch (err) {}
    }

    onUp() {
      if (!this.dragging) return;
      this.dragging = false;
      this._rafPending = false;
      this.classList.remove('is-dragging');
      window.removeEventListener('pointermove', this._move);
      window.removeEventListener('pointerup', this._up);
      window.removeEventListener('pointercancel', this._up);
      this.playActive();
    }
  }

  if (!customElements.get('agnes-spinner')) customElements.define('agnes-spinner', AgnesSpinner);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["agnes-worlds"] && !Shopify.designMode) return;
  try {
    
  // Card hover video: play the autolooping clip on hover, pause on leave
  // (mirrors the collection showcase promo behaviour).
  (function () {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Desktop-only, but decided PER EVENT — the old load-time gate left hover
    // videos dead when a narrow window was later maximised.
    const desktopHover = () =>
      window.innerWidth > 1024 && window.matchMedia('(hover: hover)').matches;
    const items = [];
    document.querySelectorAll('.agnes-worlds__card').forEach((host) => {
      const vid = host.querySelector('.agnes-worlds__video');
      if (!vid) return;
      items.push(vid);
      host.addEventListener('mouseenter', () => {
        if (!reduce && desktopHover()) { vid.play().catch(() => {}); }
      });
      host.addEventListener('mouseleave', () => { vid.pause(); });
    });
    // preload="none" made the FIRST hover download the clip cold (seconds of
    // nothing). Warm the buffer once the section approaches the viewport.
    if (items.length && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting || !desktopHover()) return;
          e.target.preload = 'auto';
          e.target.load();
          io.unobserve(e.target);
        });
      }, { rootMargin: '50%' });
      items.forEach((v) => io.observe(v));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
